export const LOAD_TYPES = {
	MATCHED_LOADS: 'Matched',
	ALL_AVAILABLE_LOADS: 'Available',
	RELOADS: 'Reloads',
};

export const LOAD_LABELS = {
	MATCHED_LOADS: 'Matched Loads',
	ALL_AVAILABLE_LOADS: 'All Available Loads',
	RELOADS: 'Reloads',
};

export const LOAD_TYPE_DROPDOWN_ITEMS = [
	{
		label: LOAD_LABELS.MATCHED_LOADS,
		value: LOAD_TYPES.MATCHED_LOADS,
		tooltipMessage: 'Shows loads matching your lanes.',
	},
	{
		label: LOAD_LABELS.RELOADS,
		value: LOAD_TYPES.RELOADS,
		tooltipMessage: 'Shows loads matching destinations where you recently booked a load.',
	},
	{
		label: LOAD_LABELS.ALL_AVAILABLE_LOADS,
		value: LOAD_TYPES.ALL_AVAILABLE_LOADS,
		tooltipMessage:
			'All loads from brokers you have worked with in the past. Loading all loads may take a little longer.',
	},
];
